/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// 404 url redirections in home page
  // if (window.location.href.indexOf("/404") >= 0) {
  //   window.location = '/';
  // }


$(document).ready(function(){
  
    // badge page target remove
  $('.link_self').removeAttr("target");

  
  // logo list section slider
  var swiper = new Swiper(".template-index .logo_list_slider", {
    slidesPerGroup: 1,
    loop: false,
    navigation: {
      nextEl: ".logo_list .swiper-button-next",
      prevEl: ".logo_list .swiper-button-prev",
    },
    breakpoints: {
      0: {
        loop: false,
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 20,
      },
      640: {
        loop: false,
        slidesPerView: 2,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 4,
      },
      990: {
        slidesPerView: 5,
      },
      1200: {
        slidesPerView: 6,
      },
    },
  });

  // Offer section slider
  var mySwiper = new Swiper(".offer_slider", {
    slidesPerGroup: 1,
    autoHeight: true,
    loop: true,
    navigation: {
      nextEl: ".offer_list_main .swiper-button-next",
      prevEl: ".offer_list_main .swiper-button-prev",
    },
    breakpoints: {
      640: {
        autoHeight: false, 
        slidesPerView: 1,
        spaceBetween: 20,
      },
      768: {
        autoHeight: false, 
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
    },
  });

  //Lazy Loading Youtube links
  var youtube = document.querySelectorAll(".page_content_data .youtube");
  for (var i = 0; i < youtube.length; i++) {
    // thumbnail image source.
    // var source = "https://img.youtube.com/vi/"+ youtube[i].dataset.embed +"/hqdefault.jpg";
    // // Load the image asynchronously
    // var image = new Image();
    //     image.src = source;
    //     image.addEventListener( "load", function() {
    //         youtube[ i ].appendChild( image );
    //     }( i ) );
    //Youtube click event to load iframe data
    youtube[i].addEventListener("click", function () {
      var iframe = document.createElement("iframe");
      iframe.setAttribute("frameborder", "0");
      iframe.setAttribute("allowfullscreen", "");
      iframe.setAttribute("width", "auto");
      iframe.setAttribute("height", "auto");
      iframe.setAttribute("allow", "autoplay,fullscreen");
      iframe.setAttribute(
        "src",
        "https://www.youtube.com/embed/" +
          this.dataset.embed +
          "?rel=0&showinfo=0&autoplay=1"
      );
      this.innerHTML = "";
      this.appendChild(iframe);
    });
  }

  //  add to cart btn active

  $(".product_qty_value").on("change keyup paste", function () {
    var value = $(this).val();
    var maxValue = $(this).attr("max");
    if (maxValue != "") {
      if (value > maxValue) {
        $(this).val(maxValue);
      }
    }
    if (value > 1) {
      $(".add_btn").removeClass("disabled");
    }
  });

  // multiple product section add to cart
  $(document).on("click", ".main_add_cart_btn .add_btn", function () {
    $("#overlay").fadeIn(300);
    Shopify.queue = [];
    $(document)
      .find(".product_qty_value")
      .each(function () {
        var this_Qty = $.trim($(this).val());
        if (this_Qty > 0) {
          var x_VarID = $.trim($(this).attr("data-value"));
          Shopify.queue.push({
            variantId: x_VarID,
            variantqty: this_Qty,
          });
        }
      })
      .promise()
      .done(function () {
        if (Shopify.queue.length != 0) {
          Shopify.moveAlong = function () {
            if (Shopify.queue.length) {
              var request = Shopify.queue.shift();
              var varid = request.variantId;
              var varqty = request.variantqty;
              $.ajax({
                method: "POST",
                url: "/cart/add.js",
                data: { id: varid, quantity: varqty },
                dataType: "json",
                success: function (res) {
                  Shopify.moveAlong();
                },
                error: function (data) {
                  Shopify.moveAlong();
                },
              });
            } else {
              $("#overlay").fadeOut(300);
              window.location.href = "/cart";
            }
          };
          Shopify.moveAlong();
        } else {
          $(document).find(".custom_loading").removeClass("loading");
        }
      });
  });

  // quick add max value set
  $(".quick_qty_value").on("change keyup paste", function () {
    var value = $(this).val();
    var maxValue = $(this).attr("max");
    if (maxValue != "") {
      if (value > maxValue) {
        $(this).val(maxValue);
      }
    }
  });

  // quick order js
  $(document).on("click", ".quick_add .quick_add_button", function () {
    var var_id = $(this).data("value");
    var qty = $(this).closest(".product_details").find(".quick_order_qty input").val();
    var option =  $(this).closest(".product_details").find(".quick_order_option select");
    if(option.length){
      console.log("I am inner")
      var_id = option.find(":selected").val();    
    }
    
    var data = {
      id: var_id,
      quantity: qty
    };

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      dataType: "json",
      success: function () {
        document.documentElement.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: {
            quantity: 1
          }
        }));
      },
      error: function () {
        console.log("error");
      },
    });
  });

  // quick order2 js
  $(document).on("click", ".quick_add2 .quick_add_button", function () {
    var id = $(this).data("id");
    var productDetails = $("#"+id).find(".quick_order_item .product_details");
    let items = [];
    productDetails.each(function(index,element){
        let price = $(element).find(".product-price").text();
        let qty = $(element).find(".quick_order_qty input").val();
        let option = $(element).find(".quick_order_option");
        let id = option.data("id");
        let defaultTest = option.data("default-test");
      
        if(!defaultTest){      
          //If product has a option selector. Use selected product variant
          id = option.find("select :selected").val()
        }
        let itemData = {
          id: id,
          quantity: qty
        };
        items.push(itemData)  

    })
    let data = {items:items};
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      dataType: "json",
      success: function () {
        document.documentElement.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: {
            quantity: 1
          }
        }));
      },
      error: function (e) {        
        console.log(e.responseJSON)
      },
    });
  });

  //Quick order change price with option select
$(document).on("change", ".quick_order_option select", function(element){  
  var price = $(this).find(":selected").data("price");
  var image = $(this).find(":selected").data("image");
  $(this).closest(".product_details").find(".product-price").text(price);
  $(this).closest(".quick_order_item").find(".image_and_titles img").attr("src",image);
})

  // quick order seaech
  
  $('.search_item input').on('keyup', function() {
	var searchVal = $(this).val();
    $('.quick_product_content').each(function() {
      
    
	var filterItems = $(this).find('.quick_order_item');
    if ( searchVal != '' ) {
        filterItems.addClass('hidden');
        $('.quick_order_item[data-name*="' + searchVal.toLowerCase() + '"]').removeClass('hidden');
    } else {
        filterItems.removeClass('hidden');
    }

    var checkLenght =  $(this).find('.quick_order_item[data-name*="' + searchVal.toLowerCase() + '"]').length;
      if ( searchVal != '' ) {
    if(checkLenght == 0){
       $(this).siblings('.heading').addClass('hide');
    }else{
       $(this).siblings('.heading').removeClass('hide');
    }
      }
    });
});


// product load
   var Url = "";
   var get_url = "";
  
  function get_data() {
      if (get_url == '') {
          var Url = "https://minutemanvac.myshopify.com/search?view=get_product_data";
      } else {
          var Url = get_url;
      }
      // alert(get_url);
      $.ajax({
          method: "GET",
          url: Url,
          dataType: "HTML",
          beforeSend: function() {},
          data: {},
      }).done(function(data) {
          var main_cat_data = $(data).find(".product_cat_all_data .main_category_filter_data").html();
          var sub_cat_data = $(data).find(".product_cat_all_data .sub_filter_data").html();
        //  var brand_data = $(data).find(".product_cat_all_data .brand_filter_data").html();
 
          if (main_cat_data != '' || sub_cat_data != '' ) {
             $("#main_category_option").append(main_cat_data);
             $("#sub_category_option").append(sub_cat_data);
           //  $("#brand_category_option").append(brand_data);
            
              var pagination = $(data).find(".pagiantion_bottom").text();
              get_url = pagination
              if (pagination != "") {  
                  $(".get_all_products").find('.pagiantion_bottom').remove();
                  get_data();
              }
              if (pagination == "") {  
              $(".select_data option").each(function() {
              $(this).siblings('[value="'+ this.value +'"]').remove();
              });
                
              }
          }
      });
  }
  get_data();



// filter Product show

  $(document).on('click','.btn_data .button',function() {
    var main_cat = $("#main_category_option option:selected").val();
    var sub_cat = $("#sub_category_option option:selected").val();
    var brand_value = $("#brand_category_option option:selected").val();

    if (main_cat != '' && sub_cat != '' && brand_value != '' ){

      var main_filter = '/collections/'+brand_value+'?sort_by=best-selling&filter.p.m.custom.sub_category_filter='+sub_cat+'&filter.p.m.custom.main_category_filter='+main_cat
      // return false;
      window.location = main_filter;

      
  }else{
      //alert('Please Select Option')
  }
  });

// product page review click scroll
    $(document).on('click','.product-block-list__item--info a[href="#product-reviews"]',function() {
      $('#product__reviews .card__collapsible-button').attr('aria-expanded','true');
      $('#product__reviews .card__collapsible').css('height','auto');
      var scrollAmount = $('#product__reviews').offset().top - 180;
      $('html, body,#product__reviews').stop().animate({scrollTop: scrollAmount}, 250);
    });
  
});

